import React from 'react';
import { CheckboxContainer, HiddenCheckbox, StyledCheckbox } from './style';
import { TbCheck } from 'react-icons/tb';

interface CheckboxProps {
  id?: string;
  className?: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  'data-testid'?: string;
}

// Checkbox component
const Checkbox = ({
  className,
  checked,
  onChange,
  disabled = false,
  'data-testid': dataTestId
}: CheckboxProps) => {
  const onClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    if (disabled) return;
    onChange(!checked);
  };
  return (
    <CheckboxContainer onClick={onClick} className={className} data-testid={dataTestId}>
      {checked || disabled ? (
        // @ts-ignore - StyledCheckbox accepts disabled prop at runtime
        <StyledCheckbox disabled={disabled}>
          <TbCheck
            fontSize="8px"
            color={disabled ? (checked ? '#ADB5BD' : 'transparent') : '#fff'}
          />
        </StyledCheckbox>
      ) : (
        <HiddenCheckbox />
      )}
    </CheckboxContainer>
  );
};

export default Checkbox;
